import { useState } from 'react'
import { stockLabel } from './nutritionFormat'

function NutritionStockButton({ disabled, onReload }) {
  const [open, setOpen] = useState(false)
  const [quantity, setQuantity] = useState('1')

  if (!open) {
    return (
      <button type="button" className="patients-btn patients-btn--ghost patients-btn--compact" onClick={() => setOpen(true)} disabled={disabled}>
        + Recarregar estoque
      </button>
    )
  }

  return (
    <form
      className="med-stock-form"
      onSubmit={(event) => {
        event.preventDefault()
        const value = Number(quantity)
        if (!Number.isFinite(value) || value <= 0) return
        onReload(value)
        setOpen(false)
        setQuantity('1')
      }}
    >
      <input
        type="number"
        min="0.01"
        step="0.01"
        value={quantity}
        aria-label="Unidades compradas"
        onChange={(event) => setQuantity(event.target.value)}
      />
      <button type="submit" className="patients-btn patients-btn--primary patients-btn--compact">Somar</button>
      <button
        type="button"
        className="patients-btn patients-btn--ghost patients-btn--compact"
        onClick={() => { setOpen(false); setQuantity('1') }}
      >
        Cancelar
      </button>
    </form>
  )
}

export function StockBadge({ item }) {
  const level = item.stock_level || 'ok'
  if (level === 'ok') return <span className="nut-stock-badge is-ok">{stockLabel(item)}</span>
  const label = level === 'empty' ? 'Acabou' : 'Acabando'
  return (
    <span className={`nut-stock-badge is-${level}`}>
      {stockLabel(item)} · {label}
    </span>
  )
}

export default NutritionStockButton
